import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';

import SafeMuiDatatable from '../generic_components/SafeMuiDatatable';
import ConfirmationModal from '../generic_components/ConfirmationModal';

import withUser from '../utils/withUser';
import * as UTILS from '../utils/utilFunctions';
import * as CONSTANTS from '../constants';
import * as CONFIG from '../config';
import TEXT_GENERAL from '../text';

// theme
const systemPartner = CONSTANTS.partner;
const THEME = require('../theme')[systemPartner];

class CandidateStatus extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      columns: this.getColumns(),

      // for removal of potentialCandidate
      showDeleteConfirmationPopUp: false,
      potentialCandidateIdDeletionRequest: '',
      projectIdForPotentialCandidateDeletionRequest: ''
    };
  }

  componentDidMount() {
    console.log(
      'this.props.selectedCandidateId',
      this.props.selectedCandidateId
    );
    // this.getProjectListByCandidateIdAPICall(this.props.selectedCandidateId);
  }

  getColumns() {
    return [
      {
        name: 'ID',
        options: {
          display: 'excluded',
          filter: false
        }
      },
      {
        name: 'Auftragsnummer',
        options: {
          display: 'true',
          filter: false,
          customBodyRender: (value, metaData) => (
            <Link
              to={`projects?id=${metaData.rowData[0]}&cid=${
                this.props.selectedCandidateId
              }&t=1`}
            >
              {value}
            </Link>
          )
        }
      },

      {
        name: 'Unternehmen',
        options: {
          display: 'true',
          filter: false
        }
      },
      {
        name: 'Position',
        options: {
          display: 'true',
          filter: false
        }
      },
      {
        name: 'Standort',
        options: {
          display: 'true',
          filter: false
        }
      },
      {
        name: 'Datum (zum Auftrag hinzugefügt)',
        options: {
          display: 'true',
          filter: false,
          customBodyRender: value => UTILS.formatStringToDELocale(value)
        }
      },
      {
        name: 'Abgesagt',
        options: {
          display: true,
          filter: false,
          customBodyRender: value =>
            value && <CheckIcon style={{ color: 'Red' }} />
        }
      },
      {
        name: 'Aktionen',
        options: {
          display: 'true',
          filter: false
        }
      }
      // {
      //   name: 'Aktion',
      //   options: {
      //     display: 'true',
      //     filter: false
      //   }
      // }
    ];
  }

  handleRemoveEntryAPICall = () => {
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    const url = CONSTANTS.removePotentialCandidateURL;

    const {
      potentialCandidateIdDeletionRequest,
      projectIdForPotentialCandidateDeletionRequest
    } = this.state;
    const payload = {
      projectId: projectIdForPotentialCandidateDeletionRequest,
      potentialCandidateId: potentialCandidateIdDeletionRequest,
      removeFrom: 'proposed'
    };
    console.log(`API ${url} request`, payload);
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      data: JSON.stringify(payload),
      timeout: CONFIG.ajaxTimeout
    })
      .done((responseBody, status) => {
        console.log(`API /${url} response`, responseBody, status);
        this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.deleteSuccess);
        const oldPotentialCandidates = this.props.data;
        const indexOfUpdatedPotentialCandidate = oldPotentialCandidates.findIndex(
          project =>
            project.potentialCandidateId === potentialCandidateIdDeletionRequest
        );
        const newPotentialCandidates = oldPotentialCandidates;
        newPotentialCandidates[indexOfUpdatedPotentialCandidate] = {
          ...newPotentialCandidates[indexOfUpdatedPotentialCandidate],
          proposed: false
        };
        this.props.liftUpUpdatedPotentialCandidates(newPotentialCandidates);

        this.handleCloseConfirmationPopUp();
      })
      .fail(err => {
        this.errorHandling(err, url);
      });
  };

  handleCloseConfirmationPopUp = () => {
    this.setState({
      showDeleteConfirmationPopUp: false,
      potentialCandidateIdDeletionRequest: ''
    });
  };

  renderDeleteConfirmationPopUp() {
    return (
      this.state.showDeleteConfirmationPopUp && (
        <ConfirmationModal
          key="confirmation-entry-deletion"
          handleClose={this.handleCloseConfirmationPopUp}
          open={this.state.showDeleteConfirmationPopUp}
          buttonPrimaryAction={this.handleRemoveEntryAPICall}
          headlineText="Kandidat aus Auftrag entfernen?"
          descriptionText="Soll der Kandidat aus dem entsprechenden Auftrag entfernt werden und auftragspezifische Daten des Kandidatens gelöscht werden?"
          // contentText={this.renderContentText()}
          // buttonPrimaryText={TEXT.adminPage.deleteUserModal.buttonPrimaryText}
        />
      )
    );
  }

  renderActionButtons(projectId, potentialCandidateId, isEditable) {
    return (
      <React.Fragment>
        {/* {this.props.user.role === 'admin' && ( */}
        <IconButton
          className=""
          disabled={!isEditable}
          aria-label="Delete"
          color="primary"
          onClick={() => {
            this.setState({
              showDeleteConfirmationPopUp: true,
              potentialCandidateIdDeletionRequest: potentialCandidateId,
              projectIdForPotentialCandidateDeletionRequest: projectId
            });
          }}
        >
          <DeleteIcon />
        </IconButton>
        {/* )} */}
      </React.Fragment>
    );
  }

  generateName(firstName, lastName) {
    let name = '';

    if (firstName) name = `${name + firstName} `;
    if (lastName) name = `${name + lastName} `;
    return name;
  }

  mapIsReferred(isReferred) {
    if (isReferred === false) return 'nein';
    if (isReferred === true) return 'ja';
    return '';
  }

  prepareDataForTable(data) {
    const formatedData = [];
    console.log('input data', data);
    if (data)
      data.forEach(entry => {
        // console.log('DEBUG CandidateStatus entry', entry);
        if (entry.proposed === true) {
          const mappedData = {
            entryId: entry.id,
            projectNumber: entry.projectNumber,
            company: entry.companyName,
            jobTitle1: entry.jobTitle1,
            partner: entry.partner,
            addedDate: entry.addedDate,
            rejectionDate: entry.rejectionDate
          };

          formatedData.push([
            ...Object.values(mappedData),
            this.renderActionButtons(
              entry.id,
              entry.potentialCandidateId,
              entry.isEditable
            )
          ]);
        }
      });
    console.log('formatedData', formatedData);
    return formatedData;
  }

  getTheme() {
    return {
      palette: THEME.app.palette,
      overrides: {
        MUIPopover: {
          root: {
            top: 0
          }
        },
        MUIDataTableViewCol: {
          root: {
            maxHeight: '350px'
          }
        },
        MUIDataTableBodyCell: {
          root: {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '10px',
            '&:nth-child(2)': {
              paddingLeft: '30px'
            },
            paddingRight: '10px',
            '&:last-child': {
              textAlign: 'right'
            }
          }
        },
        MUIDataTableHeadCell: {
          root: {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '10px',
            '&:first-child': {
              paddingLeft: '30px'
            },
            paddingRight: '10px',
            '&:last-child': {
              textAlign: 'right'
            }
          }
        }
      }
    };
  }

  getOptions() {
    return {
      filterType: 'checkbox',
      responsive: 'scroll',
      selectableRows: false,
      fixedHeader: false,
      filter: false,
      search: true,
      print: true,
      download: true,
      viewColumns: true,
      rowsPerPage: 100,
      downloadOptions: { filename: 'tableDownload.csv', separator: ';' },
      textLabels: {
        body: {
          noMatch: 'Keine passenden Einträge gefunden',
          toolTip: 'sortieren'
        },
        pagination: {
          next: 'Nächste Seite',
          previous: 'Vorherige Seite',
          rowsPerPage: 'Zeilen pro Seite:',
          displayRows: 'von'
        },
        toolbar: {
          search: 'Suche',
          downloadCsv: 'CSV downloaden',
          print: 'Drucken',
          viewColumns: 'Spalten anzeigen',
          filterTable: 'Tabelle filtern'
        },
        filter: {
          all: 'Alle',
          title: 'FILTER',
          reset: 'RESET'
        },
        viewColumns: {
          title: 'Spalten anzeigen',
          titleAria: 'Spalten anzeigen'
        },
        selectedRows: {
          text: 'rows(s) selected',
          delete: 'Delete',
          deleteAria: 'Delete Selected Rows'
        }
      }
    };
  }

  // PAGE: Vorgeschlagen auf
  render() {
    return (
      <div className="container-fluid">
        {this.renderDeleteConfirmationPopUp()}
        <div className="CandidateStatus row">
          <div className="col-12">
            {this.props.data &&
            this.props.data.length > 0 &&
            this.prepareDataForTable(this.props.data).length > 0 ? (
              <SafeMuiDatatable
                title="Vorgeschlagen auf"
                tableName="candidateStatus"
                data={this.prepareDataForTable(this.props.data)}
                columns={this.state.columns}
                options={this.getOptions()}
                muiTheme={this.getTheme()}
              />
            ) : (
              <div>
                <div className="sideBarWrapper p-2">
                  <div className="candidateArchive-emptyPage">
                    Der Kandidat wurde für keinen Auftrag vorgeschlagen
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

CandidateStatus.defaultProps = {};

CandidateStatus.propTypes = {
  // refreshCandidate: PropTypes.func.isRequired,

  selectedCandidateId: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired,
  liftUpUpdatedPotentialCandidates: PropTypes.func.isRequired
  // user: PropTypes.object.isRequired
};
export default withUser(CandidateStatus);
